import { TableHead, TableRow, TableCell, makeStyles, createStyles, TableSortLabel } from '@material-ui/core';
import React from 'react';
import { OrderDirection } from '../gql-types.generated';

export interface HeaderCell {
  id: string;
  label: string;
  sortable?: boolean;
  align?: string;
}

const useStyles = makeStyles(() =>
  createStyles({
    firstCell: {
      paddingLeft: '35px',
      background: '#F5F5F5',
      fontSize: 16,
    },
    tablecell: {
      background: '#F5F5F5',
      fontSize: 16,
      padding: '16px 4px',
    },
    sortingArrow: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    },
    sortLabel: {
      lineHeight: '1.8em',
      flexDirection: 'row-reverse',
    },
  }),
);

interface TableHeaderProps {
  cells: HeaderCell[];
  order?: OrderDirection;
  orderBy?: string;
  sortData?: (orderBy: string) => void;
  isPaymentsDue: boolean;
}

const TableHeader: React.FC<TableHeaderProps> = props => {
  const { cells, order, orderBy, sortData, isPaymentsDue } = props;
  const classes = useStyles();
  const stringOrder = order === OrderDirection.Asc ? 'asc' : 'desc';

  const handleSort = (event: React.MouseEvent<unknown>, row: HeaderCell) => {
    if (sortData) sortData(row.id);
  };

  const getAlign = (align: string | undefined): 'left' | 'right' | 'center' => {
    switch (align) {
      case 'right':
        return 'right';
      case 'center':
        return 'center';
      case 'left':
      default:
        return 'left';
    }
  };
  return (
    <TableHead>
      <TableRow>
        {cells.map((headerCell, index) => {
          return (
            <TableCell
              key={headerCell.id}
              align={getAlign(headerCell.align)}
              className={`${isPaymentsDue === false && index === 0 ? classes.firstCell : classes.tablecell}`}
            >
              {headerCell.sortable === true ? (
                <TableSortLabel
                  active={orderBy === headerCell.id}
                  direction={orderBy === headerCell.id ? stringOrder : 'desc'}
                  onClick={event => handleSort(event, headerCell)}
                  className={classes.sortLabel}
                >
                  {orderBy === headerCell.id ? (
                    <span className={classes.sortingArrow}>
                      {order === OrderDirection.Desc ? 'sorted descending' : 'sorted ascending'}
                    </span>
                  ) : null}
                  {headerCell.label}
                </TableSortLabel>
              ) : (
                headerCell.label
              )}
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
};

export default TableHeader;
